import type { RankedSlot } from "@/lib/targeting/rank-slots";
import type { UnreadPeekMessage } from "@/lib/use-visitor-unread";

/** One identity for every launcher message, so a re-pick swaps content inside the same card. */
export const LAUNCHER_MESSAGE_KEY = "launcher-message";

/**
 * The launcher bubble of a slot variant. The text is already rendered by the BE for this visitor;
 * a quick reply sends its label (the payload stays empty: a plain visitor message, no flow value).
 */
export function slotPeekMessage(r: RankedSlot, aiName: string): UnreadPeekMessage {
  return {
    id: `slot:${r.slotId}:${r.variant.id}:${r.variant.contentHash ?? ""}`,
    text: r.variant.text,
    sender: { kind: "ai", name: aiName },
    buttons: r.variant.buttons.map((b) => ({ text: b.label, payload: "" })),
    inPlaceKey: LAUNCHER_MESSAGE_KEY,
  };
}
